export default __webpack_public_path__ + "static/media/english-to-latvian-screenshot-01.ac576b55.png";